const useLocalImages =
  process.env.NODE_ENV === 'development' && process.env.GATSBY_USE_LOCAL_IMAGES === 'true';

module.exports = {
  useLocalImages,
};
